import axios from 'axios';
import { localStorageFunc } from '../utils/localStorage';

const axiosInstance = axios.create({
  baseURL: 'http://adb9-103-163-182-59.ngrok.io',

  // withCredentials: true,
});

const requestHandler = (request) => {
  // Token will be dynamic so we can use any app-specific way to always
  // fetch the new token before making the call
  const token = localStorageFunc('get','','token');

  request.headers.Authorization = `Bearer ${token}`;

  return request;
};
axiosInstance.interceptors.request.use((request) => requestHandler(request));

export { axiosInstance };
